import './eleve.scss';
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Card, Breadcrumb, Tabs } from 'antd';
import { useAppDispatch } from 'app/config/store';
import { getEleve } from './eleve.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import PersonalInfoTab from './PersonalInfo';

import { getSession } from 'app/shared/reducers/authentication';
import { UserOutlined, SolutionOutlined } from '@ant-design/icons';
import InscriptionsTab from './InscriptionsTab';

const { TabPane } = Tabs;

export const FicheEleveDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;
  const listSearch = props.location.search || '';
  const [activeTab, setActiveTab] = useState('1');

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEleve(id));

    dispatch(getEcole(ecoleId));
  }, [dispatch, id, ecoleId]);

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <>
      <Breadcrumb className="py-4">
        <Breadcrumb.Item>
          <Link aria-disabled to={`/home/${ecoleId}/${``}`}>
            École
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link
            to={{
              pathname: `/eleve/${ecoleId}`,
              search: listSearch,
            }}
          >
            Élèves
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Détails</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={handleTabChange}>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <UserOutlined />
                Informations personnelles
              </span>
            }
            key="1"
          >
            <PersonalInfoTab props={props} isActive={activeTab === '1'} />
          </TabPane>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SolutionOutlined />
                Inscriptions
              </span>
            }
            key="2"
          >
            <InscriptionsTab eleveId={id} isActive={activeTab === '2'} ecoleId={props.match.params.ecoleid} />
          </TabPane>
        </Tabs>
      </Card>
    </>
  );
};

export default FicheEleveDetail;
